import { Flex } from 'antd';
import landingImg from '../../assets/imgs/landing.png';
import star from '../../assets/imgs/landing_stars.svg';
import styles from './signin.module.scss';
import landingCurve from '../../assets/imgs/landing_curve_line.svg';
import './auth.css';
import CopyRight from '../auth-user/copyright';
import { useSelector } from 'react-redux';
import { selectCurrentTenant } from 'reducers/selectors';
import { getSystemTheme, isLightTheme } from 'utils';
import { getLocalStorage } from 'utils/cookies-util';
import cx from 'clsx';

export default function ({ children }) {
  const { tenantData } = useSelector(selectCurrentTenant);
  const getTheme = () => getLocalStorage('theme') || getSystemTheme();
  const isLight = isLightTheme(getTheme());

  const starPositionsLargeScreen = [
    { top: '72px', left: '146px' },
    { top: '274px', left: '278px' },
    { bottom: '218px', left: '126px' },
    { top: '52px', right: '125px' },
    { top: '458px', right: '174px' },
    { bottom: '156px', right: '307px' },
  ];

  const starPositionsSmallScreen = [
    { top: '103px', left: '32px' },
    { top: '270px', left: '24px' },
    { top: '72px', right: '12px' },
    { top: '236px', right: '12px' },
  ];

  return (
    <>
      <Flex vertical justify="center" align="center" gap={40} className={cx('auth-wrapper', !isLight && 'blackTheme')}>
        <div className={styles.authWrapper}>
          <div className={'auth-cover'} style={{ backgroundColor: isLight ? '#ffffff03' : 'transparent' }}>
            <img src={tenantData?.logo_url} width={200} />
            {children}
            <div className="hide-on-large">
              <CopyRight style={{ paddingTop: '0px' }} />
            </div>
          </div>
        </div>
      </Flex>
      <div className="hide-on-small">
        <CopyRight />
      </div>
      {isLight && (
        <div className={styles.backgroundLandingCover} style={{ opacity: isLight ? 1 : 0.5 }}>
          <img src={landingImg} style={{ maxWidth: '100vw' }} />
        </div>
      )}

      {/* background svg icons */}
      <div className="hide-on-small">
        {starPositionsLargeScreen.map((position, index) => {
          return <img key={index} src={star} style={{ position: 'fixed', zIndex: '99', ...position }} />;
        })}
      </div>
      <div className="hide-on-large">
        {starPositionsSmallScreen.map((position, index) => {
          return <img key={index} src={star} width={24} style={{ position: 'fixed', zIndex: '99', ...position }} />;
        })}
      </div>
      <img
        className="hide-on-small"
        src={landingCurve}
        style={{ position: 'fixed', zIndex: '99', top: '172px', left: '245px' }}
      />
      <img
        className="hide-on-large"
        width={40}
        src={landingCurve}
        style={{ position: 'fixed', zIndex: '99', top: '173px', left: '12px' }}
      />
      <img
        className="hide-on-large"
        width={40}
        src={landingCurve}
        style={{ position: 'fixed', zIndex: '99', top: '144px', right: '12px' }}
      />
    </>
  );
}
